import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';

import { ViewerRoutingModule } from './viewer-routing.module';
import { SharedModule } from '../shared/shared.module';

import { HeaderComponent } from './components/header/header.component';
import { CameraViewerComponent } from './pages/camera-viewer/camera-viewer.component';
import { ViewerRootComponent } from './viewer-root.component';
import { HelpModalComponent } from './components/helpmodal/helpmodal.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SnapshotViewerComponent } from './pages/snapshot-viewer/snapshot-viewer.component';

@NgModule({
  declarations: [
    HeaderComponent,
    CameraViewerComponent,
    SnapshotViewerComponent,
    ViewerRootComponent,
    HelpModalComponent,
  ],
  imports: [
    SharedModule,
    CommonModule,
    NgbModule,
    ViewerRoutingModule,
    ReactiveFormsModule,
    FormsModule,
  ],
})
export class ViewerModule { }
